export const common = {
  // Navigation
  'nav.home': 'Startseite',
  'nav.spreadsheet': 'CSSBuy Spreadsheet',
  'nav.products': 'Produkte',
  'nav.categories': 'Kategorien',
  'nav.guides': 'Anleitungen',
  'nav.review': 'Review',
  'nav.shipping': 'Versand',
  'nav.safety': 'Sicherheit',
  'nav.language': 'Sprache',
  'nav.visitMain': 'Hauptseite besuchen',

  // Hero
  'hero.eyebrow': 'CSSBuy Spreadsheet 2026',
  'hero.title': 'CSSBuy Spreadsheet: Finden, Vergleichen und Organisieren Sie CSSBuy-Produkte an einem Ort',
  'hero.subtitle': 'Finden Sie Tabellen, Produkte, Kategorien und CSSBuy-Anleitungen an einem Ort. Vergleichen Sie Optionen, prüfen Sie QC-, Lager- und Versandinformationen und entdecken Sie nützliche Ressourcen zur Recherche vor dem Kauf.',
  'hero.ctaPrimary': 'CSSBuy Spreadsheet erkunden',
  'hero.ctaSecondary': 'Anleitung für Anfänger',
  'hero.ctaMain': 'Hauptseite besuchen',
  'hero.trust': 'Unabhängige Ressource • Praktische Anleitungen • Vergleiche • Portugiesisch, Englisch und Deutsch',

  // Search
  'search.title': 'Finden Sie schnell, wonach Sie suchen',
  'search.placeholder': 'CSSBuy Spreadsheet, Sneakers, Hoodies, QC, Versand...',
  'search.filters': 'Spreadsheet / Produkte / QC / Versand / Anleitungen / Reviews / Gutscheine',

  // Quick Links
  'quick.spreadsheet': 'Tabelle',
  'quick.products': 'Produkte',
  'quick.qc': 'QC',
  'quick.shipping': 'Versand',
  'quick.guides': 'Anleitungen',
  'quick.reviews': 'Reviews',
  'quick.coupons': 'Gutscheine',

  // Categories
  'categories.title': 'CSSBuy Spreadsheet nach Kategorie erkunden',
  'categories.cta': 'Alle Kategorien anzeigen',

  // Value Proposition
  'value.title': 'Alles, was Sie für bessere Recherche brauchen',
  'value.find': 'Schneller finden',
  'value.findDesc': 'Organisierte Ressourcen für einfachere Recherche.',
  'value.compare': 'Optionen vergleichen',
  'value.compareDesc': 'Tabellen und Anleitungen zum Vergleich von Informationen.',
  'value.process': 'Den Prozess verstehen',
  'value.processDesc': 'Inhalte über Produkte, QC, Lager und Versand.',
  'value.safety': 'Mehr Sicherheit',
  'value.safetyDesc': 'Lernen Sie, verdächtige Links und veraltete Informationen zu erkennen.',
  'value.lang': 'Mehrsprachig',
  'value.langDesc': 'Portugiesisch, Englisch und Deutsch.',

  // Featured
  'featured.title': 'CSSBuy Spreadsheet: Hervorgehobene Ressourcen',
  'featured.cta': 'Ressource anzeigen',

  // Review
  'review.title': 'CSSBuy Review: Was Sie wissen müssen',
  'review.text': 'Bevor Sie einen internationalen Shopping-Service nutzen, ist es wichtig, Produkte, Lager, QC, Versand, Zahlungen und Risiken zu verstehen. Unser CSSBuy Review fasst die wichtigsten Punkte zusammen, um Ihre Recherche zu erleichtern.',
  'review.cta': 'CSSBuy Review lesen',

  // Shipping
  'shipping.title': 'CSSBuy Shipping Cost: Versandkosten verstehen',
  'shipping.text': 'Versandkosten können je nach Gewicht, Volumen, Zielort, Methode und aktuellen Bedingungen variieren. Bestätigen Sie immer die verfügbaren Tarife, bevor Sie einen Kauf abschließen.',
  'shipping.cta': 'CSSBuy Shipping Cost anzeigen',

  // Safety
  'safety.title': 'CSSBuy Safety: Sicherer recherchieren',
  'safety.text': 'Links können veraltet werden, Preise können sich ändern und gefälschte Seiten können versuchen, legitime Dienste zu imitieren. Lernen Sie, URLs zu verifizieren, Ihr Konto zu schützen und verdächtige Links zu vermeiden.',
  'safety.cta': 'Safety Center besuchen',

  // FAQ
  'faq.title': 'Häufig gestellte Fragen — CSSBuy Spreadsheet',
  'faq.q1': 'Was ist CSSBuy Spreadsheet?',
  'faq.a1': 'CSSBuy Spreadsheet ist eine organisierte Ressource, die Links, Produkte, Kategorien und nützliche Informationen für CSSBuy-Nutzer zusammenführt. Es erleichtert die Recherche und den Produktvergleich vor dem Kauf.',
  'faq.q2': 'Wie verwendet man ein CSSBuy Spreadsheet?',
  'faq.a2': 'Öffnen Sie die Tabelle, durchsuchen Sie die Produktkategorien, prüfen Sie Links und QC-Informationen, vergleichen Sie Preise und lesen Sie die Versandanleitungen vor dem Kauf.',
  'faq.q3': 'Wo findet man CSSBuy-Links?',
  'faq.a3': 'CSSBuy-Links finden sich in organisierten Tabellen, Community-Foren, spezialisierten Anleitungen und unabhängigen Ressourcen wie dieser Website.',
  'faq.q4': 'Was bedeutet W2C?',
  'faq.a4': 'W2C bedeutet "Where To Cop" — ein gängiger Ausdruck in Shopping-Communities, der anzeigt, wo ein bestimmtes Produkt zu finden ist.',
  'faq.q5': 'Wie überprüft man Produkte?',
  'faq.a5': 'Prüfen Sie QC-Fotos, lesen Sie detaillierte Beschreibungen, vergleichen Sie mit offiziellen Bildern und konsultieren Sie Community-Reviews vor dem Kauf.',
  'faq.q6': 'Ist CSSBuy legitim?',
  'faq.a6': 'CSSBuy ist eine bekannte Shopping-Agent-Plattform. Wie jeder internationale Dienst ist es wichtig zu recherchieren, offizielle URLs zu verifizieren und die Risiken zu verstehen.',

  // Final CTA
  'finalCta.title': 'Bereit, CSSBuy Spreadsheet zu erkunden?',
  'finalCta.text': 'Beginnen Sie mit den beliebtesten Ressourcen, vergleichen Sie Kategorien und konsultieren Sie unsere Anleitungen, bevor Sie Ihre Recherche fortsetzen.',
  'finalCta.explore': 'CSSBuy Spreadsheet erkunden',
  'finalCta.visit': 'Hauptseite besuchen',
  'finalCta.disclaimer': 'Dies ist eine unabhängige Ressource und ist nicht mit CSSBuy verbunden, gesponsert oder offiziell unterstützt.',

  // Footer
  'footer.spreadsheet': 'CSSBuy Spreadsheet',
  'footer.guides': 'Anleitungen',
  'footer.categories': 'Kategorien',
  'footer.comparisons': 'Vergleiche',
  'footer.safety': 'Sicherheit',
  'footer.about': 'Über uns',
  'footer.legal': 'Rechtliches',
  'footer.languages': 'Sprachen',
  'footer.disclaimer': 'CSSBuyBR.TOP ist eine unabhängige Ressource und ist nicht mit CSSBuy verbunden, gesponsert oder offiziell unterstützt.',
  'footer.privacy': 'Datenschutz',
  'footer.terms': 'Nutzungsbedingungen',
  'footer.disclaimerLink': 'Disclaimer',
  'footer.contact': 'Kontakt',

  // Articles
  'articles.title': 'CSSBuy Spreadsheet Artikel und Anleitungen',
  'articles.readMore': 'Artikel lesen',
  'articles.readTime': 'Min. Lesezeit',

  // Category Buttons
  'cat.shoes': 'Shoes',
  'cat.hoodies': 'Hoodies/Sweaters',
  'cat.tshirts': 'T-Shirts',
  'cat.jackets': 'Jackets',
  'cat.pants': 'Pants/Shorts',
  'cat.headwear': 'Headwear',
  'cat.sets': 'Sets',
  'cat.underwear': 'Underwear/Underpants',
  'cat.jersey': 'Jersey',
  'cat.accessories': 'Accessories',
  'cat.bags': 'Bags',
  'cat.belts': 'Belts',
  'cat.perfumes': 'Perfumes',
  'cat.other': 'Other Stuff',

  // Buttons
  'btn.cssbuySpreadsheet': 'CSSBuy Spreadsheet',
  'btn.buyItNow': 'Buy It Now',
  'btn.explore': 'Erkunden',
  'btn.readMore': 'Mehr lesen',
  'btn.backToHome': 'Zurück zur Startseite',

  // Products
  'products.title': 'CSSBuy Spreadsheet Produkte',
  'products.subtitle': 'Finden Sie die besten CSSBuy Spreadsheet-Produkte in allen Kategorien. Klicken Sie auf ein Element, um auf der Hauptseite zu kaufen.',
  'products.buyNow': 'Jetzt kaufen',
  'products.allCategories': 'Alle Kategorien',
  'products.count': 'Produkte',
  'products.noProducts': 'Keine Produkte in dieser Kategorie gefunden.',
  'products.featuredTitle': 'Hervorgehobene Produkte',
  'products.viewAll': 'Alle Produkte anzeigen',

  // Content Page
  'content.relatedPages': 'Verwandte Seiten',
  'article.disclaimerExtra': 'Dieser Artikel dient nur zu Informationszwecken. Überprüfen Sie aktuelle Informationen immer direkt bei offiziellen Quellen, bevor Sie Kaufentscheidungen treffen.',
  'content.tableOfContents': 'Inhaltsverzeichnis',
  'content.continueShopping': 'Weiter einkaufen',
  'content.visitMain': 'Hauptseite besuchen',
  'content.relatedResources': 'Verwandte Ressourcen',
  'content.backToHome': 'Zurück zur Startseite',
  'content.spreadsheetHub': 'CSSBuy Spreadsheet-Hub',
  'content.shippingCostGuide': 'Versandkosten-Guide',
  'content.browseCategories': 'Kategorien durchsuchen',
  'content.disclaimer': 'Haftungsausschluss',
  'content.published': 'Veröffentlicht',
  'content.updated': 'Aktualisiert',
  'content.by': 'Von',

  // Hero Card
  'hero.cardTitle': 'CSSBuy Spreadsheet',
  'hero.organizedResources': 'Organisierte Produktressourcen',
  'hero.categoriesCount': '14 Kategorien',
  'hero.viewAll': 'Alle anzeigen',

  // Articles
  'articles.viewAll': 'Alle anzeigen',

  // Home CTA
  'home.cta.description': 'Erkunden Sie den gesamten CSSBuy-Produktkatalog und finden Sie die besten verfügbaren Artikel.',

  // Not Found
  'notFound.title': 'Seite nicht gefunden',
  'notFound.path': 'Pfad',
  'notFound.description': 'Diese Seite wurde nicht gefunden. Gehen Sie zurück zur Startseite oder erkunden Sie unsere Ressourcen.',

  // Footer
  'footer.warehouse': 'CSSBuy Warehouse',
  'footer.coupon': 'CSSBuy Coupon',
  'footer.legit': 'Ist CSSBuy legitim?',
  'footer.faq': 'FAQ',

  // Contact
  'contact.title': 'Kontakt',
  'contact.contactUs': 'Kontaktieren Sie uns',
  'contact.messageSent': 'Nachricht gesendet',
  'contact.thankYou': 'Danke für Ihre Kontaktaufnahme. Wir melden uns bald bei Ihnen.',
  'contact.sendAnother': 'Weitere Nachricht senden',
  'contact.sendMessage': 'Nachricht senden',
  'contact.name': 'Name',
  'contact.email': 'E-Mail',
  'contact.subject': 'Betreff',
  'contact.message': 'Nachricht',
  'contact.maxChars': 'Maximal 500 Zeichen',
  'contact.description': 'Haben Sie Fragen, Feedback oder Vorschläge? Kontaktieren Sie uns und wir werden so schnell wie möglich antworten.',

  // FAQ
  'faq.stillQuestions': 'Noch Fragen?',
  'faq.exploreMore': 'Erkunden Sie weitere Ressourcen auf der Hauptseite oder kontaktieren Sie uns.',
  'faq.contactBtn': 'Kontaktieren Sie uns',
  'faq.description': 'Finden Sie Antworten auf häufige Fragen zu CSSBuy, Tabellen, Produkten, Versand und Sicherheit.',

  // Products
  'products.eyebrow': 'CSSBuy Spreadsheet 2026',

  // About
  'about.title': 'Über CSSBuyBR.TOP',
  'about.whatWeDo': 'Was wir tun',
  'about.independence': 'Unsere Unabhängigkeit',
  'about.contentPolicy': 'Inhaltsrichtlinie',
  'about.languages': 'Sprachen',
  'about.disclaimer': 'Haftungsausschluss',
  'about.primary': 'Hauptsprache',
  'about.international': 'International',
  'about.german': 'Deutsch',

  // Privacy
  'privacy.info': 'Informationen die wir sammeln',
  'privacy.use': 'Wie wir Informationen verwenden',
  'privacy.cookies': 'Cookies',
  'privacy.thirdParty': 'Links zu Drittanbietern',
  'privacy.security': 'Datensicherheit',
  'privacy.changes': 'Änderungen dieser Richtlinie',
  'privacy.contact': 'Kontakt',

  // Terms
  'terms.acceptance': 'Akzeptanz der Bedingungen',
  'terms.independent': 'Unabhängige Ressource',
  'terms.accuracy': 'Inhaltsgenauigkeit',
  'terms.noGuarantees': 'Keine Garantien',
  'terms.external': 'Externe Links',
  'terms.ip': 'Geistiges Eigentum',
  'terms.liability': 'Haftungsbeschränkung',
  'terms.changes': 'Änderungen der Bedingungen',
  'terms.governing': 'Geltendes Recht',

  // Disclaimer
  'disclaimer.independent': 'Unabhängige Ressource',
  'disclaimer.noAffiliation': 'Keine offizielle Verbindung',
  'disclaimer.accuracy': 'Richtigkeit der Informationen',
  'disclaimer.noAdvice': 'Keine professionelle Beratung',
  'disclaimer.external': 'Externe Links und Risiken',
  'disclaimer.responsibility': 'Verantwortung des Nutzers',
  'disclaimer.liability': 'Haftungsbeschränkung',
  'disclaimer.contact': 'Kontakt',
};

export default common;